









import { Component, Prop, Vue } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class BlocoDeCodigo extends Vue {
	@Prop({ type: String, required: true }) conteudo!: string
	@Prop({ type: String, default: 'Copiado para a área de transferência' }) mensagemDeCopia!: string

	copiar() {
		if (!copy(this.conteudo)) {
			AlertModule.setError('Não foi possível copiar. Selecione o texto e copie manualmente.')
			return
		}
		AlertModule.setSuccess(this.mensagemDeCopia)
	}
}
